import { createApp } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import App from './App.vue'

import BootstrapVue3 from 'bootstrap-vue-3'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue-3/dist/bootstrap-vue-3.css'

let routes = [
  { 
    path: '/login', 
    component: () => import('@/views/LoginView.vue'),
    meta: {
      displayMenu: false,
    }
  },
  { 
    path: '/politica-privacidade', 
    component: () => import('@/views/PoliticaPrivacidadeView.vue'),
    meta: {
      displayMenu: false,
    }
  },
  { path: '/', redirect: '/login' }
]

const onStorage = sessionStorage.getItem('modulos') ? JSON.parse(sessionStorage.getItem('modulos')) : []
if (onStorage.length) {
  onStorage.forEach(modulo => {
    if ('componentes' in modulo) {
      routes = [...routes, ...modulo.componentes.map(componente => ({
        path: componente.path,
        component: () => import(`@/${componente.componente}`),
        meta: {
          uuid: modulo.uuid,
          permissions: modulo.permissoes.reduce((acc, perm) => {
            acc[perm.key] = perm.status;
            return acc;
          }, {}),
          ...componente.meta 
        } || {}        
      }))]
    } else if ('submodulos' in modulo) {
      modulo.submodulos.forEach(submodulo => {
        if ('componentes' in submodulo) {
          routes = [...routes, ...submodulo.componentes.map(componente => ({
            path: componente.path,
            component: () => import(`@/${componente.componente}`),
            meta: {
              uuid: submodulo.uuid,
              permissions: submodulo.permissoes.reduce((acc, perm) => {
                acc[perm.key] = perm.status;
                return acc;
              }, {}),
              ...componente.meta 
            } || {}
          }))]
        }
      })  
    }
  })

  routes.push({ 
    path: '/my-profile', 
    component: () => import('@/views/UserProfileView.vue'),
    meta: {
      pageTitle: 'Meu Perfil',
      displayMenu: true,
      breadcrumb: [
        {
          text: 'Meu Perfil',
          active: true,
        }
      ]
    }
  })
}

// Rota catch-all para redirecionar para login qualquer rota não definida
routes.push({
  path: '/:pathMatch(.*)*',
  redirect: '/login'
})

// Criação do router
const router = createRouter({
  history: createWebHistory(),
  routes
})

// Criar a instância do app e usar o router
const app = createApp(App)
app.use(router)
app.use(BootstrapVue3)
app.mount('#app')

export { router } // Permite importação em outros arquivos
